import exportButtonComponentUrl from './exportButtonComponent.html';
class ExportButtonComponent {
  constructor(Authentication, $sce, $q, $timeout, $uibModal, $document, $compile, $scope) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      $sce,
      $q,
      $timeout,
      $uibModal,
      $document,
      $compile,
      $scope,
    });
  }

  $onInit() {
    this.url = this.$sce.trustAsResourceUrl(`${this.Authentication.baseUrl}export`);

    /**
     * <form> HTML element cannot be nested within each other https://www.w3.org/TR/xhtml1/#prohibitions
     * so it's best to dynamically create the following form element and append
     * it to <body> directly
     */
    this.formElement = this.$compile(`
      <form export-button-form action="{{ ctrl.url }}" method="post" target="_blank" get-element="ctrl.form" novalidate>
        <textarea name="data" type="hidden" ng-value="ctrl.data" class="ng-hide"></textarea>
        <input name="filename" type="hidden" ng-value="ctrl.filename" />
        <input name="format" type="hidden" ng-value="ctrl.format" />
        <input name="Authorization" type="hidden" ng-value="ctrl.Authentication.token" />
      </form>
    `)(this.$scope)[0];

    this.$document[0].body.appendChild(this.formElement);
  }

  $onDestroy() {
    this.$document[0].body.removeChild(this.formElement);
  }

  async submit() {
    if (!this.Authentication.isOrgFeatureEnabled('fileExport')) {
      throw 'Premium required';
    }

    let $options;
    if (this.withOptions) {
      $options = await this.$uibModal.open({
        size: '500',
        template: `
          <${this.withOptions}
            type="${this.format}"
            close="$close($arg)"
            dismiss="$dismiss($arg)"
          ></${this.withOptions}>
        `,
      }).result;
    }

    this.data = JSON.stringify(await this.$q.when(this.getData({ $options })));

    await this.$timeout(0); // let data bind itself to the template
    this.form[0].submit();
  }
}

export default {
  bindings: {
    getData: '&',
    pushData: '&?',
    format: '@',
    filename: '@?',
    tooltipPlacement: '@?',
    asText: '@?',
    withOptions: '@?',
  },
  controllerAs: 'ctrl',
  controller: ExportButtonComponent,
  templateUrl: exportButtonComponentUrl,
};
